import { StyleSheet } from '@react-pdf/renderer'

const PRIMARY_COLOR = '#0A3EB5'
const DETAIL_LABEL_COLOR = '#9494ac'
const LIGHT_TEXT_COLOR = '#03274A'
const BORDER_COLOR = '#e4e4e7'

const styles = StyleSheet.create({
  headerLine: {
    backgroundColor: PRIMARY_COLOR,
    height: 10,
    width: '100%'
  },
  page: {
    paddingVertical: 12,
    paddingLeft: 30,
    fontSize: 12,
    lineHeight: 1.6,
    width: '100%'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 14,
    alignItems: 'center'
  },
  textSize: {
    fontSize: 14
  },
  smallText: {
    fontSize: 12
  },
  container: {
    border: `0.5px solid ${BORDER_COLOR}`,
    borderRadius: 5
  },
  padding14: {
    padding: 14
  },
  containerNoPadding: {
    border: `0.5px solid ${BORDER_COLOR}`,
    borderRadius: 5
  },
  lightText: {
    color: LIGHT_TEXT_COLOR
  },
  paddingRight10: {
    paddingRight: 10
  },
  textPadding14: {
    paddingTop: 14
  },
  textColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  spacer: {
    marginVertical: 12
  },
  flexBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  itemsCenter: {
    alignItems: 'center'
  },
  gap8: {
    gap: 8
  },
  marginTop24: {
    marginTop: 24
  },
  marginTop16: {
    marginTop: 16
  },
  marginTop12: {
    marginTop: 12
  },
  width45: {
    width: '45%'
  },
  width55: {
    width: '55%'
  },
  textLarge: {
    fontSize: 16
  },
  textBold: {
    fontWeight: 'bold'
  },
  textBlue: {
    color: PRIMARY_COLOR
  },
  fixedWidthRow: {
    width: 145
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    gap: 16
  },
  table: {
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderColor: BORDER_COLOR,
    wrap: false
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    wrap: false
  },
  tableColHeader: {
    width: '20%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: BORDER_COLOR,
    padding: 8,
    wrap: false
  },
  tableCol: {
    width: '20%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: BORDER_COLOR,
    padding: 8,
    wrap: false
  },
  tableCellHeader: {
    margin: 'auto',
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    margin: 'auto',
    fontSize: 9
  },
  tableCellDescription: {
    margin: 'auto',
    fontSize: 9,
    textAlign: 'left'
  },
  tableCellAmount: {
    fontSize: 9,
    textAlign: 'right',
    paddingRight: 4
  },
  tableCellBalance: {
    fontSize: 9,
    textAlign: 'right',
    fontWeight: 'bold',
    paddingRight: 4
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column'
  },
  justifyCenter: {
    justifyContent: 'center'
  },
  textUnderline: {
    textDecoration: 'underline'
  },
  textCenter: {
    textAlign: 'center'
  },
  textLeft: {
    textAlign: 'left'
  },
  detailLabel: {
    fontWeight: 'bold',
    color: PRIMARY_COLOR,
    marginTop: -3,
    width: 140
  },
  detailKey: {
    width: 125,
    color: DETAIL_LABEL_COLOR,
    fontWeight: 600
  },
  footer: {
    marginTop: 60,
    fontSize: 10,
    color: '#444',
    lineHeight: 1.5
  },
  label: {
    fontWeight: 'bold'
  },
  signature: {
    marginTop: 30,
    display: 'flex',
    flexDirection: 'column',
    gap: 45
  },
  detailContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 50,
    width: '100%',
    alignItems: 'flex-start'
  },
  lineBreak: {
    borderBottom: '2px solid #f3f3fe',
    marginVertical: 10
  },
  detailContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  }
})

export default styles
